export default {
  aUniqueUsername: "Pick a unique username so your friends can find you!",
  cannotChangeUpline: "You cannot change this after this!",
  confirmUpline: "Confirm referral",
  isYourUpline: "Is your referral: ",
  step: "Step",
  setupSecretKey: "Finally! Where are you from?",
  secretKeyHint: "Never share your secret key with anyone!",
  secretKeyDescription:
    "Your secret key is required when performing certain operations: ",
  referralDescription:
    "Referral is the person who introduced our products to you. You must get his/her username to proceed to next step. **This is an agent-only portal.",
  requestShipping: "Request Shipment",
  cashWithdrawal: "Cash withdrawal",
  restock: "Restock",
  whoIntroducedYou: "Who's your referral?",
};
